import { useContext, useState } from "react";
import FavoritesContext from "../store/favorites-context";
import MeetupList from "../components/layout/meetups/MeetupList";
import FavCard from "./FavCard";
import { useEffect } from "react";
import { getDoc } from "firebase/firestore";
import AppLoader from "../components/layout/ui/Apploader";
import { AuthContext } from "../store/auth-context";
import Alert from "react-bootstrap/Alert";
import { useNavigate } from "react-router-dom";
import classes from "./Favorites.module.css";

function FavoritesPage() {
	const favoritesCtx2 = useContext(FavoritesContext);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const [meetups, setMeetups] = useState([]);

	//initialize navigation hook for navigation
	const navigate = useNavigate();

	//extract user state from authContext
	const { user } = useContext(AuthContext);

	const createAccount = () => navigate("/signup");

	const browseDestinations = () => navigate("/");

	useEffect(() => {
		const loadFavorites = async () => {
			const favorites = favoritesCtx2.favorites;
			try {
				if (favorites.length === 0) {
					return;
				}
				setLoading(true);
				setError(false);

				//Create an array of promises and load meetup
				const promises = favorites.map((favorite) =>
					getDoc(favorite.favorite)
				);
				const meetup_docs = await Promise.all(promises);

				//Get meetup data from docs
				const get_meetups = meetup_docs.map((meetup_doc) => ({
					id: meetup_doc.id,
					...meetup_doc.data(),
				}));
				setMeetups(get_meetups);
			} catch (error) {
				console.error(error);
				setError(true);
			} finally {
				setLoading(false);
			}
		};
		loadFavorites();
	}, [favoritesCtx2.favorites]);
	console.log(favoritesCtx2.favorites);

	return (
		<section>
			<h1
				style={{
					fontFamily: "monospace",
					color: "#1E90FF",
					fontWeight: "bold",
					marginTop: "1rem",
					marginBottom: "1rem",
				}}
			>
				Favorite Earthscapes
			</h1>

			{error && (
				<Alert
					style={{
						textAlign: "center",
						width: "65%",
						marginLeft: "15%",
					}}
				>
					Sorry, there was an error loading your favorites, please try
					again later!
				</Alert>
			)}

			{loading && (
				<AppLoader color={"#007FFF"} loading={true} size={50} />
			)}

			{/* The below UI will be shown when user is authenticated, but has no favorites */}
			{!loading && favoritesCtx2.totalFavorites === 0 && user && (
				<FavCard>
					<div className={classes.favoriteImg}>
						<img src="./images/favorite.png" alt="favorites" />
					</div>
					<div className={classes.emptyFavs}>
						<p>
							No Favorites yet, add some
						</p>
						<button
							onClick={browseDestinations}
							className={classes.emptyFavsBtns}
						>
							Browse Destinations
						</button>
					</div>
				</FavCard>
			)}

			{/*Below UI is shown if user is not authenticated */}
			{!loading && favoritesCtx2.totalFavorites === 0 && !user && (
				<FavCard>
					<div className={classes.favoriteImg}>
						<img src="./images/favorite.png" alt="favorites" />
					</div>
					<div className={classes.emptyFavs}>
						<p>
							Create an account to view favorites.
						</p>
						<button
							onClick={createAccount}
							className={classes.emptyFavsBtns}
						>
							Create Account
						</button>
					</div>
				</FavCard>
			)}

			{/* Below UI is shown if user is authenticated and has favorites to show */}
			{!loading && favoritesCtx2.totalFavorites > 0 && (
				<MeetupList meetups={meetups} />
			)}
		</section>
	);
}

export default FavoritesPage;
